import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'
import VueTheMask from 'vue-the-mask'

Vue.use(Vuetify)
Vue.use(VueTheMask)

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    themes: {
      light: {
        success: colors.teal.base,
        error: colors.pink.base
      }
    }
  }
})
